import styled from 'styled-components'
import { tokens } from '@arvoreeducacao/bonsai-ds'

export const EmptySpaceWrapper = styled.div<{ textColor?: string }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  padding: ${tokens.spacing.insetMedium} 0;
  width: 100%;

  font-size: ${tokens.fontSize.medium};
  color: ${({ textColor }) => (textColor ? textColor : tokens.colors.dark5)};

  border: 1px solid ${tokens.colors.dark2};
  border-radius: ${tokens.radius.large};

  margin: ${tokens.spacing.verticalMedium} 0px;
`
